const getTicket = (prefix, quantity) => {
   const calc1 = (quantity + 1) % 26;
   const calc2 = quantity * 3;

   const ticket = `RPC${prefix}${String.fromCharCode(97+calc1)}${calc2}`;
   return ticket;
}

export default getTicket;
